// 좌측 사이드바(32rem)와 우측 목차(28rem)가 함께 열려도
// 본문에 64rem이 남는 최소 너비입니다.
// 이보다 좁으면 우측 목차 대신 접이식 목차 바(AsideMobile)를 사용합니다.
export const ASIDE_BREAKPOINT = 1360;
